<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>

            </v-card>
            <v-tabs v-model="tabs" fixed-tabs>
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#summaryReport" class="primary--text">
                ประวัติการขอเบิกสวัสดิการ
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item value="summaryReport">
                <v-card>
                        <v-simple-table>
              <template v-slot:default>
              <thead>
                  <tr  style="background-color: #1b437c">
                    <th class="text-center">
                      ประเภทสวัสดิการ
                    </th>
                    <th class="text-center">
                      ยอดที่เบิก
                    </th>
                    <th class="text-center">
                      ติดตามผล
                    </th>
                  </tr>
                </thead>
                  <tbody>
                      <tr
                        v-for="item in dataItem"
                        :key="item.welfareRequest"
                      >
                        <td class="text-center">
                          {{item.welfareRequest}}
                          </td>
                        <td class="text-center">
                          {{item.welfareAmount}}
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'draft'">
                          <v-chip
                            class="ma-2"
                            color="primary"
                            outlined
                          >
                            ตรวจสอบเอกสาร
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'verify'">
                          <v-chip
                            class="ma-2"
                            color="indigo darken-3"
                            outlined
                          >
                            ผู้จัดการสาขา
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'confirm'">
                          <v-chip
                            class="ma-2"
                            color="deep-purple accent-4"
                            outlined
                          >
                            ฝ่ายบุคคล
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'approve'">
                          <v-chip
                            class="ma-2"
                            color="orange"
                            outlined
                          >
                            การเงิน
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'finish'">
                          <v-chip
                            class="ma-2"
                            color="success"
                            outlined
                          >
                            อนุมัติ
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'unapprove'">
                          <v-chip
                            class="ma-2"
                            color="red"
                            outlined
                          >
                            ไม่อนุมัติ
                          </v-chip>
                          </td>
                        <td class="text-center" v-if="item.welfare_status == 'cancel'">
                          <v-chip
                            class="ma-2"
                            color="red"
                            outlined
                          >
                            ยกเลิก
                          </v-chip>
                          </td>
                      </tr>
                    </tbody>
              </template>
            </v-simple-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
            <p></p>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
// import moment from 'moment'
// moment().format('YYYY')
import monthNameTH from '../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../assets/master/Date/yearsNumber.json'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'Info',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      imageUrlBack: '',
      imageHeadHRM: '',
      dataItem: [],
      year: '',
      month: '',
      day: '',
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      tabs: 'tabInfo'
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')

    await this.getDataReport()
    // }
  },
  methods: {
    Home () {
      this.$router.push('/Liff/HomeWelfare')
    },
    async getDataReport () {
      this.dataItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/welfare/get?empCode=' + this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data

          console.log('this.dataItem', this.dataItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/WelfareHistory.vue